import { MicroFrontend } from '@praxis/component-microfrontend'
import apiConfig from '../../globalConfig/apiConfig'
import { LoadingProfileMfe } from '../common/LoadingProfileMfe' // Import Redux store
import store from '../../store'

export const ItemMFE = ({ ...rest }) => {
  const path = `${apiConfig.remotes.search}/remoteEntry.js`
  return (
    <>
      <MicroFrontend
        module="./Search"
        src={path}
        anyProp={'any value'}
        Loading={LoadingProfileMfe}
        parentStore={store}
        {...rest}
      ></MicroFrontend>
    </>
  )
}
